export default __webpack_public_path__ + "static/favicon-4a86024a06226e7466e2de9262d9f3cf.ico";